import {BaseModel} from "../../../../infrastructure/models/base-model";
import {AppTerms} from "../../../app/app-terms";
import {DidomiConfigNoticeContentModel} from "./didomi-config.notice.content-model";
import {DIDOMI_NOTICE} from "../../../consts";

export class DidomiConfigNoticeModel extends BaseModel {
  terms: AppTerms;
  isRtl: Boolean;
  language: String;

  constructor(terms: AppTerms, isRtl: Boolean, language: String) {
    super();

    this.terms = terms;
    this.isRtl = isRtl;
    this.language = language;
  }

  get textAlignment(): String {
    return this.isRtl ? DIDOMI_NOTICE.TEXT_ALIGNMENT.right : DIDOMI_NOTICE.TEXT_ALIGNMENT.left
  }

  get content(): DidomiConfigNoticeContentModel {
    const content: DidomiConfigNoticeContentModel = !this.language ? new DidomiConfigNoticeContentModel(this.terms) : null;

    return content;
  }

  getDidomiObject() {
    return {
      textAlignment: this.textAlignment,
      content: this.content?.getDidomiObject()
    }
  }
}